// src/pages/Pricing.jsx
import React from "react";
import { pricingPlans } from "../data/mockData";
import { Check } from "lucide-react";
import { Link } from "react-router-dom";
import CheckoutButton from "../components/CheckoutButton";

const Pricing = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col">
      <header className="py-8 bg-transparent">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 dark:text-white mb-2">
            Pricing
          </h1>
          <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            Simple plans for researchers — choose the right fit for your work.
          </p>
        </div>
      </header>

      <main className="flex-1 container mx-auto px-4 py-16">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row items-stretch gap-8 justify-center">
            {pricingPlans.map((plan) => {
              const isPopular = plan.popular;
              return (
                <div
                  key={plan.name}
                  className={`relative flex-1 rounded-2xl p-8 bg-white dark:bg-gray-800 border ${isPopular ? "border-primary-600 shadow-xl transform scale-105" : "border-gray-200 dark:border-gray-700"}`}
                  style={{ minWidth: 260, maxWidth: 360 }}
                >
                  {isPopular && (
                    <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                      <span className="bg-primary-600 text-white px-4 py-1 rounded-full text-sm font-semibold">
                        Most Popular
                      </span>
                    </div>
                  )}

                  <div className="text-center mb-6">
                    <h3 className="text-2xl font-bold text-gray-900 dark:text-white">
                      {plan.name}
                    </h3>
                    <div className="flex items-baseline justify-center mt-3">
                      <span className="text-4xl font-extrabold text-gray-900 dark:text-white">
                        {plan.price}
                      </span>
                      <span className="text-sm text-gray-500 dark:text-gray-400 ml-2">
                        /{plan.period}
                      </span>
                    </div>
                  </div>

                  <ul className="mb-6 space-y-3">
                    {plan.features.map((f, idx) => (
                      <li key={idx} className="flex items-start gap-3">
                        <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700 dark:text-gray-300">{f}</span>
                      </li>
                    ))}
                  </ul>

                  <div className="mt-auto">
                    {/* If the plan is Free -> Current Plan disabled button */}
                    {plan.name === "Free" ? (
                      <button className="w-full py-3 rounded-lg font-medium bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white">
                        Current plan
                      </button>
                    ) : plan.priceId ? (
                      <CheckoutButton priceId={plan.priceId}>
                        {plan.buttonText || (plan.name === "Free" ? "Current plan" : "Buy now")}
                      </CheckoutButton>
                    ) : (
                      <button
                        className="w-full py-3 rounded-lg font-medium bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white"
                        onClick={() => window.alert("Please contact sales for enterprise pricing.")}
                      >
                        {plan.buttonText || "Contact Sales"}
                      </button>
                    )}

                    <div className="mt-3 text-center">
                      <Link to="/contact" className="text-sm text-gray-600 dark:text-gray-400 hover:underline">
                        Contact sales
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="mt-8 text-center text-sm text-gray-600 dark:text-gray-400">
            <p>All plans include email support and access to the API. Volume discounts available for teams.</p>
          </div>
        </div>
      </main>

      <footer className="py-8 text-center text-gray-600 dark:text-gray-400">
        © 2025 PaperMind AI
      </footer>
    </div>
  );
};

export default Pricing;
